import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Rooms from "@/pages/Rooms";
import Bookings from "@/pages/Bookings";
import CalendarPage from "@/pages/CalendarPage";
import Invoices from "@/pages/Invoices";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import GuestExports from "@/pages/GuestExports";
import Settings from "@/pages/Settings";
import ArrivalPage from "@/pages/ArrivalPage";
import Guests from "@/pages/Guests";
import Cleaning from "@/pages/Cleaning";
import Auditorium from "@/pages/Auditorium";
import Mensa from "@/pages/Mensa";
import { canSee } from "@/lib/sections";

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="font-display text-2xl text-muted-foreground animate-pulse">FAAM WebServices…</div>
  </div>
);

const Protected = ({ children, adminOnly, section }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (!canSee(user, section)) return <Navigate to="/" replace />;
  return children;
};

const LoginGate = () => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginGate />} />
            <Route path="/arrivo/:id" element={<ArrivalPage />} />
            <Route path="/mensa/schermo" element={<Protected section="mensa"><Mensa kiosk /></Protected>} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="calendario" element={<Protected section="calendar"><CalendarPage /></Protected>} />
              <Route path="prenotazioni" element={<Protected section="bookings"><Bookings /></Protected>} />
              <Route path="ospiti" element={<Protected section="guests"><Guests /></Protected>} />
              <Route path="pulizie" element={<Protected section="cleaning"><Cleaning /></Protected>} />
              <Route path="camere" element={<Navigate to="/camere/nord" replace />} />
              <Route path="camere/:building" element={<Protected section="rooms"><Rooms /></Protected>} />
              <Route path="adempimenti" element={<Protected section="exports"><GuestExports /></Protected>} />
              <Route path="fatture" element={<Protected section="invoices"><Invoices /></Protected>} />
              <Route path="auditorium" element={<Protected section="auditorium"><Auditorium /></Protected>} />
              <Route path="mensa" element={<Protected section="mensa"><Mensa /></Protected>} />
              <Route path="report" element={<Navigate to="/report/nord" replace />} />
              <Route
                path="report/:building"
                element={
                  <Protected section="reports">
                    <Reports />
                  </Protected>
                }
              />
              <Route
                path="impostazioni"
                element={
                  <Protected adminOnly>
                    <Settings />
                  </Protected>
                }
              />
              <Route
                path="utenti"
                element={
                  <Protected adminOnly>
                    <Users />
                  </Protected>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
